/**
 * @fileoverview Barrel exports for the short-story-planner-v4 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  SourceMaterialSchema,
  FlowSourceMaterialSchema,
  transformSourceMaterial,
  type Input,
  type Output,
  type HookInput,
  type SourceMaterial,
  type FlowSourceMaterial,
  type PlotThreadOutput,
  type CharacterArcOutput,
} from './schema';

// Flow
export { flow } from './flow';

// Prompt template
export { prompt } from './prompt';
